import React from "react";
import { StepProgressBar } from "./progress-bar";
import { StatusInfo } from "./status-info";
import { Col } from "@amzn/stencil-react-components/layout";
import { Spinner, SpinnerSize } from "@amzn/stencil-react-components/spinner";
import useArb from "../../hooks/use-arb";

interface ApplicationStatusControlledProps {
  startDateStatus?: string;
  nheCompleted?: boolean;
  afterFirstDay?: boolean;
  loading?: boolean;
  error?: boolean;
}

export const ApplicationStatusControlled = ({
  startDateStatus,
  nheCompleted,
  afterFirstDay,
  loading,
  error,
}: ApplicationStatusControlledProps) => {
  const bundle = useArb("HVHChecklistPantherResource");

  const loadingText = bundle.getMessage("checklist-General-TaskStatus-Loading");

  if (loading) {
    return (
      <Col alignItems="center">
        <Spinner
          size={SpinnerSize.Small}
          loadingText={loadingText}
          showText={true}
        />
      </Col>
    );
  }

  if (
    error ||
    startDateStatus === undefined ||
    nheCompleted === undefined ||
    afterFirstDay === undefined
  ) {
    return null;
  }

  const steps = [
    {
      name: "Application",
      isCompleted: true,
      isActive: false,
    },
    {
      name: "Appointment",
      isCompleted: nheCompleted,
      isActive: !nheCompleted,
    },
    {
      name: "First day",
      isCompleted: nheCompleted && afterFirstDay,
      isActive: nheCompleted && !afterFirstDay,
    },
  ];

  return (
    <>
      <Col gridGap="2rem" alignItems="center">
        <StepProgressBar steps={steps} />
        <StatusInfo
          startDateStatus={startDateStatus}
          nheCompleted={nheCompleted}
        />
      </Col>
    </>
  );
};
